const contentfulIds = {
  blog: "6g9yeRSHe33VsSoVUb6ux",
  portfolio: "1sDLneEeo9bEBPEU2w0QbR",
}

module.exports = contentfulIds
